import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { AvStatusPillComponent } from '../../../../../Shared/Components/av-status-pill/av-status-pill.component';
import { COMMON_IMPORTS } from '../../../../../Shared/common-imports';
import { scaleCount } from '../../../../../Shared/Services/count-up-value.util';
import { TranslationService } from '../../../../../Shared/Services/translation.service';
import { MonitoringLifetime } from '../../../Interfaces/monitoring-report.interface';
import { formatDurationParts } from '../../../Shared/monitoring-duration.util';
import { formatMonthName } from '../../../Shared/monitoring-month-name.util';
import { MonitoringDeltaComponent } from '../monitoring-delta/monitoring-delta.component';

@Component({
  selector: 'app-monitoring-duration-card',
  standalone: true,
  imports: [COMMON_IMPORTS, AvStatusPillComponent, MonitoringDeltaComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './monitoring-duration-card.component.html',
  host: { class: 'av-metric-card av-metric-card--compact' },
})
export class MonitoringDurationCardComponent {
  readonly lifetime = input.required<MonitoringLifetime>();
  readonly progress = input<number>(1);
  readonly previousFrom = input<string | null>(null);

  protected readonly language = inject(TranslationService).currentLanguage;

  protected readonly monthName = computed(() => formatMonthName(this.language()));

  protected readonly parts = computed(() =>
    formatDurationParts(this.lifetime().average_seconds).map((part) => ({
      ...part,
      value: scaleCount(part.value, this.progress()),
    })),
  );

  protected readonly delta = computed(() => this.lifetime().delta_percent);
}
